export default `<html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns:m="http://schemas.microsoft.com/office/2004/12/omml" xmlns="http://www.w3.org/TR/REC-html40">
<head>
<meta http-equiv="Content-Type" content="text/html; charset=iso-8859-1">
<meta name="Generator" content="Microsoft Word 15 (filtered medium)">
<!--[if !mso]><style>v\:* {behavior:url(#default#VML);}
o\:* {behavior:url(#default#VML);}
w\:* {behavior:url(#default#VML);}
.shape {behavior:url(#default#VML);}
</style><![endif]--><style><!--
/* Font Definitions */
@font-face
\t{font-family:"Cambria Math";
\tpanose-1:2 4 5 3 5 4 6 3 2 4;}
@font-face
\t{font-family:Aptos;}
@font-face
\t{font-family:"Open Sans";
\tpanose-1:0 0 0 0 0 0 0 0 0 0;}
/* Style Definitions */
p.MsoNormal, li.MsoNormal, div.MsoNormal
\t{margin:0cm;
\tfont-size:10.0pt;
\tfont-family:"Open Sans",sans-serif;
\tmso-ligatures:standardcontextual;
\tmso-fareast-language:EN-US;}
span.E-MailFormatvorlage17
\t{mso-style-type:personal-compose;
\tfont-family:"Open Sans",sans-serif;
\tcolor:windowtext;}
.MsoChpDefault
\t{mso-style-type:export-only;
\tmso-fareast-language:EN-US;}
@page WordSection1
\t{size:612.0pt 792.0pt;
\tmargin:70.85pt 70.85pt 2.0cm 70.85pt;}
div.WordSection1
\t{page:WordSection1;}
--></style><!--[if gte mso 9]><xml>
<o:shapedefaults v:ext="edit" spidmax="1026" />
</xml><![endif]--><!--[if gte mso 9]><xml>
<o:shapelayout v:ext="edit">
<o:idmap v:ext="edit" data="1" />
</o:shapelayout></xml><![endif]-->
</head>
<body lang="DE" link="#467886" vlink="#96607D" style="word-wrap:break-word">
<div class="WordSection1">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.48%;background:white;border-collapse:collapse">
<tbody>
<tr>
<td valign="top" style="padding:0cm 0cm 0cm 0cm">
<div align="center">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr>
<td style="padding:0cm 0cm 0cm 0cm">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" align="left" width="600" style="width:450.0pt;background:white;border-collapse:collapse;margin-left:-2.25pt;margin-right:-2.25pt">
<tbody>
<tr>
<td style="padding:0cm 15.0pt 0cm 15.0pt">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr>
<td width="560" valign="top" style="width:420.0pt;padding:0cm 0cm 0cm 0cm">
<div align="center">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr>
<td style="padding:0cm 0cm 0cm 0cm;font-family:&quot;Open Sans&quot;,sans-serif;font-size:10.0pt;color:black">
<!-- bodyContentStart --><p class="MsoNormal" style="line-height:12.0pt;mso-line-height-rule:exactly"><a name="_MailAutoSig"><span style="font-size:10.0pt;font-family:&quot;Open Sans&quot;,sans-serif;color:black;mso-fareast-language:ZH-CN;mso-no-proof:yes">
`;
